import { filter } from "rxjs/operators";
import { take } from "rxjs";
import { Component, OnDestroy, OnInit, Input,ChangeDetectionStrategy } from "@angular/core";
import {
  SharedModule,
  DataService,
  TypedBaseListComponent,
} from "@bb-vendure/admin-ui/core";
import { FetchUserPointsDocument } from "src/generated-gql/graphql";

@Component({
  selector: "user-points-records-table",
  standalone: true,
  imports: [SharedModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./table.component.html",
})
export default class UserPointTableComponent
  extends TypedBaseListComponent<typeof FetchUserPointsDocument, "userPoints">
{
  @Input() customerId: string;

  constructor(protected dataService: DataService) {
    super();
    super.configure({
      document: FetchUserPointsDocument,
      getItems: (result) => {
        return result.userPoints;
      },
      setVariables: (skip, take) => ({
        options: {
          skip,
          take,
          filter: {
            customerId: {
              eq: this.customerId,
            },
            ...this.filters.createFilterInput(),
          },
          sort: this.sorts.createSortInput(),
        },
      }),
      refreshListOnChanges: [
        this.filters.valueChanges,
        this.sorts.valueChanges,
      ],
    });
  }
  filters = this.createFilterCollection()
    .addIdFilter()
    .connectToRoute(this.route);
  sorts = this.createSortCollection()
    .defaultSort("createdAt", "DESC")
    .connectToRoute(this.route);
}
